import React from 'react';
import styled from 'styled-components';
import { joyDocHelper } from '@builttocreate/engine-utils';
import { applyLogic } from '@joyfill/conditional-logic';

import PageExporter from './PageExporter';

import PageLayoutModes from '../../../constants/PageLayoutModes';
import FieldModes from '../../../constants/FieldModes';

import { ThemeProvider } from '../../../theme/ThemeContext';
import getThemeObject from '../../../theme/getThemeObject';

const { getPageOrder, sortPages } = joyDocHelper;

const StyledPageWrapper = styled.div`
  display: flex;
  border-width: 0px !important;

  * {

    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
      width: 0px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
  }
`;

const JoyDocExporter = ({ doc, theme }) => {

  const pageNodes = [];

  if (!doc || !doc.fields) return null;

  const fieldLookup = {};
  doc.fields.forEach((field) => {
    if (!fieldLookup[field.file]) fieldLookup[field.file] = {};
    fieldLookup[field.file][field._id] = field;
  });

  doc.files.forEach((file) => {

    const pages = applyLogic(
      sortPages(file.pages, getPageOrder(file.pageOrder, file.pages)),
      doc.fields,
      '_id'
    ).filter((item) => !item.hidden);

    pages.forEach((page) => {

      const {
        _id,
        layout,
        presentation,
        width,
        height,
        backgroundImage,
        fieldPositions,
        cols,
        rowHeight,
        margin,
        padding,
        borderWidth,
        borderColor,
        borderStyle
      } = page;

      let fields = [];

      fieldPositions.forEach((fieldPosition) => {

        if (!fieldLookup[file._id][fieldPosition.field]) return;

        fields.push({
          ...fieldLookup[file._id][fieldPosition.field],

          //IMPORTANT: DO NOT REMOVE.
          //FieldPositon must come after targetField
          ...fieldPosition,
        });

      });

      fields = applyLogic(fields, doc.fields, '_id').filter((item) => !item.hidden);

      pageNodes.push(
        <StyledPageWrapper key={_id}>
          <PageExporter
            id={_id}
            mode={FieldModes.readonly}
            enableVirtualFields={false}
            enableFieldMeasurementRendering={layout === PageLayoutModes.grid}
            enablePageBreakAdjustments
            fieldDefaultStyles={file.styles}
            {...{
              layout,
              presentation,
              width,
              height,
              backgroundImage,
              fields,
              cols,
              rowHeight,
              margin,
              padding,
              borderWidth,
              borderColor,
              borderStyle
            }}
          />
        </StyledPageWrapper>
      );

    });

  });

  return (
    <ThemeProvider value={getThemeObject(theme)}>
      {pageNodes}
    </ThemeProvider>
  );

};

export default React.memo(JoyDocExporter);
